import { RxWebSocketReadyState } from 'messaging'
import { SocketStatusAction, ConnectionActionTypes } from 'store/connection'
import { RepositoryActionReset, RepositoryActionTypes } from 'store/repository'
import { ActivityMonitorActions, ActivityMonitorActionTypes } from './activityMonitorActions'
import { Activity, ActivityMonitorStore } from './activityTypes'

const initialState: ActivityMonitorStore = {
  activities: []
}

type ActivityMonitorReducerActions = ActivityMonitorActions | SocketStatusAction | RepositoryActionReset

export function activityMonitorReducer(
  state: ActivityMonitorStore = initialState,
  action: ActivityMonitorReducerActions
): ActivityMonitorStore {
  switch (action.type) {
    case ActivityMonitorActionTypes.ACTIVITY_CREATE: {
      const newActivity: Activity = action.payload
      const existingActivities = state.activities.filter(activity => activity.id !== newActivity.id)
      const updatedActivities = existingActivities.concat([newActivity])
      return { ...state, activities: updatedActivities }
    }

    case ActivityMonitorActionTypes.ACTIVITIES_CREATE: {
      const newActivities: Activity[] = action.payload
      const existingActivities = state.activities.filter(activity => !newActivities.some(newActivity => activity.id === newActivity.id))
      const updatedActivities = existingActivities.concat(newActivities)
      return { ...state, activities: updatedActivities }
    }

    case ActivityMonitorActionTypes.ACTIVITY_COMPLETE: {
      const newActivity: Activity = action.payload
      const updatedActivities = state.activities.map(activity => {
        return activity.id === newActivity.id
          ? {
              ...activity,
              respondedStatus: newActivity.negotiationUpdate.entity.status
            }
          : activity
      })
      return { ...state, activities: updatedActivities }
    }

    case ActivityMonitorActionTypes.ACTIVITIES_COMPLETE: {
      const newActivities = action.payload

      const updatedActivities = state.activities.map(stateActivity => {
        if (newActivities[stateActivity.id]) {
          return {
            ...stateActivity,
            respondedStatus: newActivities[stateActivity.id].negotiationUpdate.entity.status
          }
        }
        return stateActivity
      })
      return { ...state, activities: updatedActivities }
    }

    case ConnectionActionTypes.SOCKET_STATUS:
      return action.payload.readyState === RxWebSocketReadyState.Closed ? initialState : state

    case RepositoryActionTypes.REPOSITORY_RESET:
      return initialState

    default: {
      return state
    }
  }
}
